"use client"

import { useEffect, useState, useCallback } from "react"
import { usePathname } from "next/navigation"

const BANNER_SRC = "https://1057665e82f.vws.vegacdn.vn/okwinstatic/images/banner-sidebar-okwin.gif"

export default function SideBanners() {
  const [showLeftBanner, setShowLeftBanner] = useState(true)
  const [showRightBanner, setShowRightBanner] = useState(true)
  const pathname = usePathname()

  // Always re-show on route change
  useEffect(() => {
    setShowLeftBanner(true)
    setShowRightBanner(true)
  }, [pathname])

  const closeLeftBanner = useCallback(() => {
    setShowLeftBanner(false)
  }, [])

  const closeRightBanner = useCallback(() => {
    setShowRightBanner(false)
  }, [])

  return (
    <>
      {/* Left Banner */}
      {showLeftBanner && (
        <div className="hidden 2xl:block fixed top-1/2 -translate-y-1/2 left-0 z-20">
          <div className="relative">
            <div className="w-full">
              <a href="https://3456789day.com/?f=2843315" target="_blank" rel="noopener noreferrer">
                <img src={BANNER_SRC} style={{ width: '100px' }} alt="Banner" />
              </a>
              <a href="https://3456789day.com/?f=2843315" target="_blank" rel="noopener noreferrer">
                <img src={BANNER_SRC} style={{ width: '100px' }} alt="Banner" />
              </a>
            </div>
            <span 
              className="adlv-close absolute w-8 h-8 rounded-full bg-white flex items-center justify-center cursor-pointer -top-4 -right-4"
              onClick={closeLeftBanner}
              aria-label="Đóng banner trái"
            >
              <svg width="20px" height="20px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
                <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
                <g id="SVGRepo_iconCarrier">
                  <path 
                    fillRule="evenodd" 
                    clipRule="evenodd" 
                    d="M5.29289 5.29289C5.68342 4.90237 6.31658 4.90237 6.70711 5.29289L12 10.5858L17.2929 5.29289C17.6834 4.90237 18.3166 4.90237 18.7071 5.29289C19.0976 5.68342 19.0976 6.31658 18.7071 6.70711L13.4142 12L18.7071 17.2929C19.0976 17.6834 19.0976 18.3166 18.7071 18.7071C18.3166 19.0976 17.6834 19.0976 17.2929 18.7071L12 13.4142L6.70711 18.7071C6.31658 19.0976 5.68342 19.0976 5.29289 18.7071C4.90237 18.3166 4.90237 17.6834 5.29289 17.2929L10.5858 12L5.29289 6.70711C4.90237 6.31658 4.90237 5.68342 5.29289 5.29289Z" 
                    fill="#0F1729"
                  />
                </g>
              </svg>
            </span>
          </div>
        </div>
      )}

      {/* Right Banner */}
      {showRightBanner && (
        <div className="hidden 2xl:block fixed top-1/2 -translate-y-1/2 right-0 z-20">
          <div className="relative">
            <div className="w-full">
              <a href="https://3456789day.com/?f=2843315" target="_blank" rel="noopener noreferrer">
                <img src={BANNER_SRC} style={{ width: '100px' }} alt="Banner" />
              </a>
              <a href="https://3456789day.com/?f=2843315" target="_blank" rel="noopener noreferrer">
                <img src={BANNER_SRC} style={{ width: '100px' }} alt="Banner" />
              </a>
            </div>
            <span 
              className="adlv-close absolute w-8 h-8 rounded-full bg-white flex items-center justify-center cursor-pointer -top-4 -left-4"
              onClick={closeRightBanner}
              aria-label="Đóng banner phải"
            >
              <svg width="20px" height="20px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
                <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
                <g id="SVGRepo_iconCarrier">
                  <path 
                    fillRule="evenodd" 
                    clipRule="evenodd" 
                    d="M5.29289 5.29289C5.68342 4.90237 6.31658 4.90237 6.70711 5.29289L12 10.5858L17.2929 5.29289C17.6834 4.90237 18.3166 4.90237 18.7071 5.29289C19.0976 5.68342 19.0976 6.31658 18.7071 6.70711L13.4142 12L18.7071 17.2929C19.0976 17.6834 19.0976 18.3166 18.7071 18.7071C18.3166 19.0976 17.6834 19.0976 17.2929 18.7071L12 13.4142L6.70711 18.7071C6.31658 19.0976 5.68342 19.0976 5.29289 18.7071C4.90237 18.3166 4.90237 17.6834 5.29289 17.2929L10.5858 12L5.29289 6.70711C4.90237 6.31658 4.90237 5.68342 5.29289 5.29289Z" 
                    fill="#0F1729"
                  />
                </g>
              </svg>
            </span>
          </div>
        </div>
      )}
    </>
  )
} 